module.exports = __webpack_public_path__ + "static/fonts/iconfont.1b4bc2d5.woff2";